import React, { useContext, useEffect, useState } from "react";
import "./Your_Pickup_Information.css";
import Select from "react-select";
import Prev_Btn from "../../../../common/common-btn/prev-btn/Prev_Btn";
import Next_Btn from "../../../../common/common-btn/next-btn/Next_Btn";
import { Context } from "../../../../../utils/context";
import { useForm } from "react-hook-form";

const Your_Pickup_Information = ({ setActiveTab }) => {


  const {
    IMG_URL,
    Select2Data,
    getData,
    postData,
    BookingData,
    setBookingData
  } = useContext(Context);

  const {
    register, control, reset,
    handleSubmit, watch, setValue,
    formState: { errors },
  } = useForm();
  const [location, setLocation] = useState("Alchi monastery");
  const handleNext = () => {
    setActiveTab("yourdetails");
  };

  const handleBack = () => {
    setActiveTab("price");
  };
  const timeOptions = [
    { value: "08:00 AM", label: "08:00 AM" },
    { value: "09:00 AM", label: "09:00 AM" },
    { value: "10:00 AM", label: "10:00 AM" },
    { value: "11:00 AM", label: "11:00 AM" },
  ];


  const resetFormData = async () => {
    await reset({
      pickup_at: BookingData?.pickup_at,
      pickup_location: BookingData?.pickup_location || "",

    })
  }

  useEffect(() => {
    resetFormData()
  }, [BookingData]);

  const onSubmit = async (data) => {
    console.log("Form Data:", data);
    const formData = new FormData();

    formData.append("pickup_location", data?.pickup_location);
    formData.append("pickup_at", data?.pickup_at);

    const response = await postData(`/without-login/booking/step-1/${BookingData?.id}`, formData);
    if (response?.success) {
      // setTimeout(() => {
      await handleNext()
      // }, 2500);
    } else {
      // setApiError(response?.errors)
      console.error("Form submission failed:", response?.errors);
    }
  };
  return (
    <section className="Your_Pickup_Information Your_Booking_Conditions">
      <div className="booking_card">
        <div className="row justify-content-center">
          <form onSubmit={handleSubmit(onSubmit)}>

            <div className="col-lg-8">
              <h6 className="booking_headings">Pick-up Information</h6>
              <div className="info_row">
                <span>Select pick-up time </span>
                <span>:</span>
                <span>

                  <input
                    type="time"
                    className="pickup_select"
                    {...register("pickup_at", {
                      required: "Pickup time is required",
                    })}
                  />

                  {errors?.pickup_at && (
                    <p className="text-danger">
                      {errors.pickup_at.message}
                    </p>
                  )}
                </span>
              </div>

              <div className="info_row">
                <span>Pick-up location </span>
                <span>:</span>
                <span>
                  <input
                    type="text"
                    className="pickup_input"
                    {...register("pickup_location", {
                      required: "Location is required",
                      maxLength: {
                        value: 250,
                        message: "Maximum 250 characters allowed",
                      },
                    })}
                  />
                  {errors?.pickup_location && (
                    <p className="text-danger">
                      {errors.pickup_location.message}
                    </p>
                  )}
                </span>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div className="both_btn_holder">
        <div onClick={handleBack}>
          <Prev_Btn text="Back" />
        </div>
        <div onClick={handleSubmit(onSubmit)}>
          {/* <div onClick={handleNext}> */}
          <Next_Btn text="Next" />
        </div>
      </div>
    </section>
  );
};

export default Your_Pickup_Information;
